"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var Query_1 = require("./Query");
var url_1 = require("../utils/url");
var UrlQuery = /** @class */ (function (_super) {
    __extends(UrlQuery, _super);
    function UrlQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UrlQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    UrlQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, code = _a.code, codeQuery = _a.codeQuery, key = _a.key, keyQuery = _a.keyQuery, urlPattern = _a.urlPattern, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ key: key,
            keyQuery: keyQuery,
            urlPattern: urlPattern,
            codeQuery: codeQuery, code: code }, (options.url || {}));
    };
    UrlQuery.prototype.getRawValue = function (executionOptions, callStackLevel) {
        if (callStackLevel === void 0) { callStackLevel = 1; }
        var _a = this.options, code = _a.code, key = _a.key, urlPatternQueryOptions = _a.urlPattern;
        if (code) {
            if (key && code === 'param' && urlPatternQueryOptions && typeof urlPatternQueryOptions === 'object') {
                var urlPatternQuery = new Query_1.Query(urlPatternQueryOptions, this.translationHelper, callStackLevel + 1);
                var urlPattern = urlPatternQuery.execute(executionOptions);
                var urlPatternOptions = this.orchestrateUrl(urlPattern);
                if (urlPatternOptions && urlPatternOptions.isValid) {
                    var currentUrlOptions = this.orchestratePathname(window.location.pathname);
                    if (currentUrlOptions.isValid &&
                        urlPatternOptions.pieceCount === currentUrlOptions.pieceCount &&
                        urlPatternOptions.pieces &&
                        currentUrlOptions.pieces) {
                        var index = urlPatternOptions.pieces.indexOf(":" + key);
                        if (index > -1) {
                            return currentUrlOptions.pieces[index];
                        }
                    }
                }
            }
            if (key && code === 'queryString') {
                return url_1.getQueryStringValue({ key: key }, window.location.search);
            }
            if (window.location.hasOwnProperty(code)) {
                var windowResponse = window.location[code];
                if (typeof windowResponse !== 'function') {
                    return window.location[code];
                }
            }
        }
        return;
    };
    UrlQuery.prototype.orchestratePathname = function (pathname) {
        var pieces;
        var isValid = true;
        if (!pathname || pathname.length === 0) {
            isValid = false;
        }
        if (isValid) {
            pieces = pathname.substr(1).split('/');
        }
        // Remove the last parameter if it is empty
        if (pieces && pieces.length > 0 && (pieces[pieces.length - 1] === undefined || pieces[pieces.length - 1] === null || pieces[pieces.length - 1].length === 0)) {
            pieces.pop();
        }
        return {
            pieces: pieces,
            isValid: isValid,
            pathname: pathname,
            pieceCount: pieces ? pieces.length : 0,
        };
    };
    UrlQuery.prototype.orchestrateUrl = function (url) {
        var pathname = '';
        var isValid = true;
        var workingUrl = url;
        var hasHostname = workingUrl.startsWith('http://') || workingUrl.startsWith('https://');
        if (!hasHostname) {
            var separator = url.startsWith('/') ? '' : '/';
            workingUrl = "https://www.fakeurl.com" + separator + url;
        }
        try {
            var url_2 = new URL(workingUrl);
            pathname = url_2.pathname;
        }
        catch (e) {
            isValid = false;
        }
        if (!isValid) {
            return {
                isValid: isValid,
                pathname: pathname,
            };
        }
        return this.orchestratePathname(pathname);
    };
    return UrlQuery;
}(BaseQuery_1.BaseQuery));
exports.UrlQuery = UrlQuery;
//# sourceMappingURL=UrlQuery.js.map